import React, { useEffect, useRef, useState } from 'react';

import './AddUpdateMessagesAccueil.scss'
import ImageWithTextTemplate from "../../Components/TemplatesEditor/ImageWithTextTemplate/ImageWithTextTemplate ";
import {addMessageAccueil, deleteMessage, getMessagesAccueil, updateMessage} from "../../api/messagesAccueilService";
import { containsTextOrImage, sanitizedMsg } from "../../utils/htmlUtils";
import {fromDateInputToDdSlashMmSlashYyyy, isAfterToday, isBeforeToday} from "../../utils/dateUtils";
import moment from "moment";
import ReactDOMServer from "react-dom/server";
import LoadingOverlay from "../../Components/LoadingOverlay/LoadingOverlay";
import { renderError } from "../../utils/formUtils";
import { useSelector } from "react-redux";

import { useNavigate, useLocation } from 'react-router-dom';

// TODO pour modifier les messages il faut voir comment extraire les images de l'existant
// TODO virer un des deux html
export default function AddUpdateMessagesAccueil() {

    const navigate = useNavigate();
    const location = useLocation();

    const {
        messagesAccueil,
        loadingMessages,
    } = useSelector(state => ({
        ...state.keycloakReducer,
        ...state.resourcesReducer,
    }))

    const CONF = window?.confPub;

    // TODO Faire une version avec reducer et généraliser à l'app
    const [isLoading, setIsLoading] = useState(true)
    const [submitted, setSubmitted] = useState(false)
    const [messagesAccueilDisplay, setMessagesAccueilDisplay] = useState([])
    const [includeArchivedMessages, setIncludeArchivedMessages] = useState(false)
    // TODO ajouter des boutons adéquates
    const [includeUnpublishedMessages, setIncludeUnpublishedMessages] = useState(true)
    const [limit, setLimit] = useState(10)

    const [htmlFromServer, setHtmlFromServer] = useState('');

    const initFormulaire = {
        datePublication: {
            value: "",
            invalid: "Date de publication obligatoire",
        },
        dateFinPublication: {
            value: "",
            invalid: "",
        },
        corps: {
            value: "",
            invalid: "Message obligatoire",
        },
    }

    const [message, setMessage] = useState(initFormulaire)

    const cleanInputsRef = useRef(null);
    const setCleanFunction = (childFunction) => {
        cleanInputsRef.current = childFunction;
    };

    let displayedMessageCount = 1

    const fetchMessagesAccueil = async () => {
        try {

            const messagesAccueil = await getMessagesAccueil(
                {
                    limit,
                    includeArchivedMessages,
                    includeUnpublishedMessages
                }
            )

            setMessagesAccueilDisplay(messagesAccueil)

        } catch (err) {

            console.log("err", err)
        }
    }

    useEffect(() => {

        fetchMessagesAccueil()

        setIsLoading(false)

    }, [includeUnpublishedMessages, includeArchivedMessages])


    // TODO utiliser ça pour faire une historisation des routes
    useEffect(() => {
        // const location = useLocation()
        console.log('new route: ', location)

    }, [location]);

    const handleMessage = (jsx) => {

        let invalid = false

        if (!containsTextOrImage(jsx)) {
            invalid = "Message obligatoire"
        }

        setMessage({
            ...message,
            corps: {
                ...message?.corps,
                value: jsx,
                invalid: invalid,
            }
        })
    }

    const handleInput = (e) => {

        const { name, value, type } = e?.target

        let invalid = false

        if (type === 'date') {

            if (name === "datePublication" && !value) {

                invalid = "Date de publication obligatoire"
            } else if (!moment(value).isValid()) {

                invalid = "Date invalide"
            } else if (name === "dateFinPublication") {

                const YYYY_DASH_MM_DASH_DD = CONF?.PATTERNS?.YYYY_DASH_MM_DASH_DD

                invalid = moment(value, YYYY_DASH_MM_DASH_DD).isBefore(message?.datePublication?.value, YYYY_DASH_MM_DASH_DD) ? "La date de fin de publication doit se situer après la date de publication" : false
            }

        } else if (type === "text") {

            invalid = !value ? "Corps obligatoire" : false
        }

        setMessage((prevState) => ({
            ...prevState,
            [name]: {
                value: value,
                invalid: invalid,
            }
        }));
    }

    const handleSubmit = async (e) => {

        e.preventDefault()
        setIsLoading(true)
        setSubmitted(true)

        if (containsTextOrImage(message?.corps?.value) && !message?.datePublication?.invalid) {

            const dataToSend = {
                ...message,
                datePublication: message?.datePublication?.value,
                dateFinPublication: message?.dateFinPublication?.value,
                corps: ReactDOMServer.renderToStaticMarkup(message?.corps?.value),
            }

            console.log("dataToSend")
            console.log(dataToSend)

            try {

                const contributionAdded = await addMessageAccueil(dataToSend)
                console.log("contributionAdded", contributionAdded)

            } catch (err) {

                console.log("err", err)

            } finally {

                fetchMessagesAccueil()

                setMessage(initFormulaire)
                setSubmitted(false)
                setHtmlFromServer('')

                if (cleanInputsRef.current) {
                    cleanInputsRef.current();
                }

                setIsLoading(false)
            }
        } else {
            setIsLoading(false)
        }
    }

    const supprimerMessage = async (id) => {

        if (id) {
            try {

                const messageDelete = await deleteMessage(id)
                console.log('Contribution supprimé :', messageDelete);

            } catch (err) {

                console.log("err", err)

            } finally {

                fetchMessagesAccueil()
            }
        }
    }

    const archiverMessage = async (id) => {

        const yesterday = moment().subtract(1, 'day').format(CONF?.PATTERNS?.YYYY_DASH_MM_DASH_DD)
        const dataToSend = {
            dateFinPublication: yesterday,
        }

        if (id) {
            try {

                const messageDelete = await updateMessage(id, dataToSend)
                console.log('Contribution supprimé :', messageDelete);

            } catch (err) {

                console.log("err", err)
            } finally {

                fetchMessagesAccueil()
            }
        }
    }

    return (

        <div className='container add-update-msg-container overlay-container mt-3'>
            <main id='content' className='overlay-container'>

                { isLoading && <LoadingOverlay classes="upload-overlay"/> }

                <form onSubmit={ (e) => handleSubmit(e) }>
                    <div className="card">
                        <div className="card-header">
                            <h1>Ajouter un message d&apos;accueil</h1>
                        </div>

                        <div className="card-body">

                            <div>
                                <h2>Prévisualisation :</h2>

                                <div className='preview message-window'>
                                    { message?.corps?.value }
                                </div>

                            </div>

                            <div className='mt-3'>
                                <h2>Formulaire :</h2>

                                <div className="row">
                                    <div className="col-md-4 mt-3">


                                            <label
                                                htmlFor="datePublication"
                                                className="me-2">
                                                Date de publication :
                                            </label>
                                            <input
                                                id="datePublication"
                                                name="datePublication"
                                                className="form-control"
                                                type="date"
                                                value={ message?.datePublication?.value }
                                                onChange={ handleInput }/>



                                        { submitted && message?.datePublication?.invalid && renderError(message?.datePublication?.invalid) }
                                    </div>

                                    <div className="col-md-4 mt-3">
                                        <label
                                            htmlFor="dateFinPublication"
                                            className="me-2">
                                            Date de fin de publication :
                                        </label>
                                        <input
                                            id="dateFinPublication"
                                            name="dateFinPublication"
                                            className="form-control"
                                            type="date"
                                            value={ message?.dateFinPublication?.value }
                                            onChange={ handleInput }/>

                                        { submitted && message?.dateFinPublication?.invalid && renderError(message?.dateFinPublication?.invalid) }
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-12">
                                        <ImageWithTextTemplate
                                            initialHtml={ htmlFromServer }
                                            onChange={ (html) => setHtmlFromServer(html) }
                                            setJsxContent={ handleMessage }
                                            acceptSecondImage={ false }
                                            triggerCleanFunction={ setCleanFunction }
                                        />
                                        { submitted && message?.corps?.invalid && renderError(message?.corps?.invalid) }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card-footer">
                            <button
                                className="btn btn-primary float-end"
                                type="submit"
                            >
                                Sauvegarder
                            </button>
                        </div>

                    </div>
                </form>

                <div className="card mt-4">
                    <div className="card-header">
                        <h1>Modifier/Supprimer des messages d&apos;accueil</h1>
                    </div>

                    <div className="card-body">
                        <div className={ 'mt-3' }>

                            { messagesAccueilDisplay?.length > 0 && (
                                <h2>Les 10 messages les plus récents</h2>
                            ) }

                            <ul className={ 'list-unstyled mt-3' }>
                                { messagesAccueilDisplay?.length > 0 ? messagesAccueilDisplay?.map((message, index) => {

                                    let corpsParsed = ""

                                    if (message?.corps !== undefined) {
                                        try {
                                            corpsParsed = JSON.parse(message.corps);
                                        } catch (error) {
                                            console.error("Failed to parse JSON:", error, message.corps);
                                            corpsParsed = "Format du message invalide";
                                        }
                                    }

                                    let supply = ''
                                    let messageTitle = "Message en réserve"

                                    const unpublished = isAfterToday(message?.datePublication)
                                    const archived = isBeforeToday(message?.dateFinPublication)

                                    if (archived) {
                                        supply = 'messages-archived'
                                        messageTitle = "Message archivé"
                                    } else if (unpublished) {
                                        messageTitle = "Message bientôt publié"
                                        supply = 'messages-unpublished'
                                    } else if (displayedMessageCount < 4) {
                                        supply = 'messages-selected'
                                        messageTitle = "Message sur l'écran d'accueil"
                                        displayedMessageCount++
                                    }

                                    return (
                                        <li key={ `message-${ index }` } className={ 'py-2' }>

                                            <div className="card">
                                                <div
                                                    className={ `card-header ${ supply }` }
                                                >

                                                    <h2>{ messageTitle }</h2>

                                                    <div>
                                                        <div>
                                                            <span>
                                                                date de publication : { fromDateInputToDdSlashMmSlashYyyy(message?.datePublication) }
                                                                &nbsp;| date de fin publication : { fromDateInputToDdSlashMmSlashYyyy(message?.dateFinPublication) }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card-body">
                                                    <div
                                                        className={ 'message-window' }
                                                        dangerouslySetInnerHTML={ sanitizedMsg(corpsParsed) }/>
                                                </div>

                                                <div
                                                    className={ `card-footer d-flex ${ !archived ? 'justify-content-between' : 'justify-content-end' }` }>

                                                    { !archived && (
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={ () => archiverMessage(message?.id) }
                                                        >
                                                            Archiver le message
                                                        </button>
                                                    ) }

                                                    <button
                                                        className="btn btn-secondary"
                                                        onClick={ () => supprimerMessage(message?.id) }
                                                    >
                                                        Supprimer message
                                                    </button>

                                                </div>
                                            </div>
                                        </li>
                                    )
                                }) : (
                                    <li className={ 'py-2' }>
                                        <h3 className='text-center'>Aucun message d&apos;accueil trouvé</h3>
                                    </li>
                                ) }
                            </ul>
                        </div>
                    </div>

                    <div className="card-footer">
                        <button
                            className="btn btn-grey white-text float-end"
                            onClick={ () => setIncludeArchivedMessages(!includeArchivedMessages) }
                        >
                            { includeArchivedMessages ? "Masquer" : "Afficher" } les messages archivés
                        </button>
                    </div>
                </div>

            </main>
        </div>
    )
}